module.exports = __webpack_public_path__ + "img/telegram.1049d99b.svg";